import {Deck} from '../model/models'

export default class DeckLogic {
  static getImageUrl(deck: Deck | null) {
    if (!deck || !deck.imageMeta) {
      return '/images/image_placeholder.png'
    }
    return `/api/image/${deck.imageMeta.id}${deck.imageMeta.ext}`
  }
}
